// English translations
export const en = {
  // Common
  common: {
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    submit: 'Submit',
    search: 'Search',
    filter: 'Filter',
    clear: 'Clear',
    yes: 'Yes',
    no: 'No',
    ok: 'OK',
    optional: 'Optional',
    saving: 'Saving...'
  },

  // Header
  header: {
    myEvents: 'My Events',
    myRides: 'My Rides',
    account: 'Account',
    logout: 'Logout',
    loginSignUp: 'Login / Sign Up',
    createEvent: 'Create Event',
    home: 'Home'
  },

  // Event Code Entry
  eventCode: {
    title: 'Welcome back,',
    subtitle: 'What would you like to do today?',
    joinEvent: 'Join Event',
    enterEventCode: 'Enter Event Code',
    eventCodePlaceholder: 'Enter event code',
    joinButton: 'Join',
    myEvents: 'My Events',
    noEvents: 'No events yet',
    createNewEvent: 'Create New Event',
    invalidCode: 'Invalid event code. Please try again.',
    pleaseEnterCode: 'Please enter an event code',
    eventFound: 'Event found!',
    loggedOut: 'Logged out successfully',
    createEventDesc: 'Organize a new event',
    offerRide: 'Offer a Ride',
    shareCar: 'Share your car',
    findRide: 'Find a Ride',
    requestSeat: 'Request a seat',
    viewAll: 'View All',
    alreadyHaveAccount: 'Already have an account?'
  },

  // Login
  login: {
    title: 'Welcome to Trempi',
    subtitle: 'Enter your phone number to get started',
    phoneNumber: 'Phone Number',
    phonePlaceholder: 'Enter your phone number',
    sendOTP: 'Send OTP',
    enterOTP: 'Enter the 6-digit code we sent you',
    otpPlaceholder: 'Enter 6-digit code',
    verify: 'Verify',
    resendOTP: 'Resend OTP',
    resendIn: 'Resend code in',
    seconds: 's',
    completeRegistration: 'Complete Registration',
    name: 'Full Name',
    namePlaceholder: 'Enter your full name',
    email: 'Email Address',
    emailPlaceholder: 'Enter your email',
    gender: 'Gender',
    genderMale: 'Male',
    genderFemale: 'Female',
    genderOther: 'Other',
    hidePhone: 'Hide my phone number',
    hidePhoneHint: 'Others can only contact you after you approve their ride request',
    register: 'Create Account',
    welcome: 'Welcome',
    invalidOTP: 'Invalid OTP',
    pleaseCompleteRegistration: 'Please complete your registration',
    createAccount: 'Create Account',
    invalidPhone: 'Please enter a valid 10-digit phone number starting with 0',
    fillDetails: 'Please fill in your details to create an account',
    codeSent: 'Code sent! Your verification code is:',
    welcomeBack: 'Welcome back! Login code sent.',
    failedToSendOTP: 'Failed to send OTP',
    otpAlreadySent: 'An OTP was already sent. Please enter it below.',
    enter6DigitOTP: 'Please enter the 6-digit OTP',
    pleaseEnterName: 'Please enter your name',
    pleaseEnterValidEmail: 'Please enter a valid email',
    pleaseSelectGender: 'Please select your gender',
    verificationCodeSent: 'Verification code sent!',
    codeResent: 'Code resent! Your verification code is:',
    otpResent: 'OTP resent to your phone',
    failedToResendOTP: 'Failed to resend OTP',
    sending: 'Sending...',
    sendingOTP: 'Sending OTP...',
    verifying: 'Verifying...',
    codeSentTo: 'Code sent to',
    termsOfService: 'By continuing, you agree to our Terms of Service',
    smsHint: 'We\'ll send you a verification code via SMS'
  },

  // Landing Page
  landing: {
    heroTitle: 'Ride Together, Save Together',
    heroSubtitle: 'Connect with fellow travelers, reduce costs, and make your commute more enjoyable.',
    getStarted: 'Get Started',
    learnMore: 'Learn More',
    connectNetwork: 'Connect & Network',
    connectDescription: 'Meet amazing people on your daily commute. Build meaningful connections and expand your professional network while sharing rides.',
    connectionsMade: 'connections made',
    saveFuel: 'Save on Fuel',
    saveDescription: 'Cut your transportation costs by up to 75%. Share expenses with fellow travelers and keep more money in your pocket.',
    savedCollectively: 'saved collectively',
    ecoFriendly: 'Eco-Friendly',
    ecoDescription: 'Reduce your carbon footprint and contribute to a greener planet. Every shared ride makes a difference.',
    co2Reduced: 'CO₂ reduced',
    howItWorks: 'How It Works',
    step1Title: 'Enter Event Code',
    step1Description: 'Get your unique event code from the organizer and enter it to join the carpool network.',
    step2Title: 'Choose Your Role',
    step2Description: 'Decide if you want to offer a ride as a driver or request one as a passenger.',
    step3Title: 'Connect & Ride',
    step3Description: 'Match with compatible travelers, confirm your ride, and enjoy the journey together!',
    testimonials: 'What Our Users Say',
    getStartedNow: 'Get Started Now',
    readyToStart: 'Ready to start your carpool journey?'
  },

  // Homepage (EventCodeEntry / landing)
  homepage: {
    welcomeName: 'Welcome', // show "Welcome, {firstName}" when logged in
    heroTag: 'Smarter rides for better events',
    heroTitleLine1: 'Your Event.',
    heroTitleLine2: 'Your Community.',
    heroTitleLine3: 'One Ride at a Time.',
    heroSubtitle: 'Turn every journey into an opportunity. Connect with fellow attendees, share experiences, and arrive together. Networking starts before you even get there.',
    eventCodePlaceholder: 'Enter event code or link',
    join: 'Join',
    offerRide: 'Offer a Ride',
    requestRide: 'Request a Ride',
    offerTremp: 'Offer a Ride',
    requestTremp: 'Request a Ride',
    previewEventTitle: 'Wedding - Sarah & Mike',
    previewRidesCount: '6 rides',
    rideRouteSample1: 'Tel Aviv → Haifa • Leaving 4:30 PM',
    rideRouteSample2: 'Jerusalem → Haifa • Leaving 3:00 PM',
    latestEventsTag: 'Latest Events',
    discoverEvents: 'Discover Events',
    discoverSubtitle: 'Join exciting events and connect with fellow attendees',
    searchPlaceholder: 'Search events by name, location, or code...',
    noEventsFound: 'No events found matching',
    featuresTag: 'Features',
    everythingYouNeed: 'Everything You Need',
    featuresSubtitle: 'Powerful features designed to make carpooling effortless',
    impactTag: 'Impact',
    betterForEveryone: 'Better for Everyone',
    impactSubtitle: 'Carpooling isn\'t just convenient – it\'s a choice that benefits you, your community, and the planet.',
    ctaTitle: 'Ready to Ride Together?',
    ctaSubtitle: 'Join the community of event-goers who\'ve discovered that the journey is just as important as the destination.',
    createEventBtn: 'Create Event',
    joinEventBtn: 'Join Event',
    eventCodeCopied: 'Event code copied!',
    // Feature cards
    featureEventCentric: 'Event-Centric',
    featureEventCentricDesc: 'Built specifically for events. Weddings, conferences, meetups – coordinate rides in one central hub.',
    featureTrustFirst: 'Trust First',
    featureTrustFirstDesc: 'Share rides with people attending the same event. Common interests build instant trust.',
    featureConnectInstantly: 'Connect Instantly',
    featureConnectInstantlyDesc: 'One-tap WhatsApp messaging and calling. Coordinate pickup points effortlessly.',
    featureSmartMatching: 'Smart Matching',
    featureSmartMatchingDesc: 'Our algorithm matches drivers and passengers along optimal routes.',
    featurePrivacyControls: 'Privacy Controls',
    featurePrivacyControlsDesc: 'Share only what you want. Hide your phone, email, or name from others.',
    featureNoAppNeeded: 'No App Needed',
    featureNoAppNeededDesc: 'Works in any browser. Share a link and everyone can join instantly.',
    // Impact labels
    savingsLabel: 'Average savings on travel costs',
    fewerCarsLabel: 'Fewer cars at event venues',
    co2SavedLabel: 'CO₂ saved per shared ride',
    connectionsLabel: 'Connections waiting to happen',
    // Legacy keys (keep for compatibility)
    heroTitle: 'Carpool to your event — together.',
    createEvent: 'Create Event',
    joinWithCode: 'Join with Code',
    enterEventCode: 'Enter event code',
    pasteHelper: 'Paste the code you received (example: ',
    goToEvent: 'Go to Event',
    findingEvent: 'Finding event...',
    pleaseEnterCode: 'Please enter an event code',
    invalidFormat: 'Invalid code format. Use letters, numbers, dash or underscore only.',
    eventNotFound: 'Event not found. Please check the code and try again.',
    recentEvents: 'Recent Events',
    howItWorksTitle: 'How It Works',
    howItWorksSubtitle: 'Up and Running in Minutes',
    howItWorksDescription: 'No complex setup. No app downloads. Just create, share, and go.',
    step1Title: 'Create Event',
    step1Description: 'Set up your event with date, time, and location in seconds.',
    step2Title: 'Share Link',
    step2Description: 'Send the unique link to all attendees via any messaging app.',
    step3Title: 'Offer or Request',
    step3Description: 'Drivers offer seats, passengers request rides based on routes.',
    step4Title: 'Match & Go',
    step4Description: 'Connect, coordinate pickup, and travel together!',
    impactTitle: 'Impact',
    impactDescription: 'Carpooling isn\'t just convenient – it\'s a choice that benefits you, your community, and the planet.',
    networkingTitle: 'Networking',
    networkingSubtitle: 'Networking Starts in Your Car',
    networkingDescription: 'The best connections happen in unexpected places. A 45-minute drive with a fellow attendee can lead to partnerships, friendships, and opportunities.',
    connectionMade: 'Connection made 45 min before event',
    sharedInterestsTitle: 'Shared Interests',
    sharedInterestsDescription: 'You\'re already going to the same place. Common ground is built-in.',
    uninterruptedTimeTitle: 'Uninterrupted Time',
    uninterruptedTimeDescription: 'No crowds, no noise. Real conversations that actually go somewhere.',
    warmIntrosTitle: 'Warm Introductions',
    warmIntrosDescription: 'Arrive together and you\'ve already got someone to introduce you around.',
    safetyTitle: 'Trust & Safety',
    safetySubtitle: 'Ride with People You Can Trust',
    safetyDescription: 'When everyone\'s going to the same event, you already have something in common. That shared context creates instant trust and better conversations.',
    mutualConnectionsTitle: 'Mutual Connections',
    mutualConnectionsDescription: 'See shared friends and connections before you ride.',
    ratingsTitle: 'Driver Ratings & Reviews',
    ratingsDescription: 'Real feedback from real riders.',
    verifiedTitle: 'Verified Profiles',
    verifiedDescription: 'Phone verification ensures everyone is who they say they are.',
  },

  // Event Dashboard
  eventDashboard: {
    home: 'Home',
    myRides: 'My Rides',
    eventTitle: 'Event',
    publishRide: 'Publish Ride',
    findRide: 'Find Ride',
    adminPanel: 'Admin Panel',
    availableRides: 'Available Rides',
    myRide: 'My Ride',
    noRidesAvailable: 'No rides available yet',
    beFirst: 'Be the first to publish a ride!',
    loadingRides: 'Loading rides...',
    errorLoadingRides: 'Error loading rides',
    offerRide: 'Offer a Ride',
    requestRide: 'Request a Ride',
    needRide: 'Need a Ride',
    ridesAvailable: 'Offers',
    ridesNeeded: 'Requests',
    joined: 'joined',
    myConfirmedRides: 'My Confirmed Rides',
    ridingWith: 'Riding with',
    pickup: 'Pickup',
    destination: 'Destination',
    call: 'Call',
    whatsapp: 'WhatsApp',
    showing: 'Showing',
    of: 'of',
    rides: 'rides',
    clearFilters: 'Clear filters',
    filterRides: 'Filter rides',
    narrowResults: 'Narrow by trip type, seats, payment & more',
    noRidesMatchFilters: 'No rides match your filters',
    adjustFilters: 'Try adjusting your filters to see more rides',
    noRidesOffered: 'No rides offered yet',
    beFirstToOffer: 'Be the first to offer a ride to this event!',
    myOffer: 'My Offer',
    full: 'Full',
    seats: 'seats',
    driver: 'Driver',
    matchesYourRequest: 'Matches your request!',
    confirmed: 'Confirmed',
    manage: 'Manage',
    requests: 'Requests',
    requestToJoin: 'Request to Join',
    going: 'Going',
    return: 'Return',
    startingFrom: 'Starting from',
    arriving: 'Arriving',
    dropoff: 'Drop-off',
    stops: 'stops',
    selectPickup: 'Select Pickup Location',
    selectDropoff: 'Select Drop-off Location',
    choosePickup: '-- Choose pickup point --',
    chooseDropoff: '-- Choose drop-off point --',
    enterCustomLocation: 'Enter custom location...',
    customPickup: 'Custom Pickup Location',
    enterAddress: 'Enter your address...',
    selectedLocations: 'Selected Locations',
    choosePickupOnRoute: 'Choose pickup location on route',
    enterAddressManually: 'Enter address manually',
    enterPickupAddress: 'Enter pickup address...',
    orSelectOnMap: 'Or select on map',
    pickupSelected: 'Pickup location selected',
    noPickupSelected: 'No pickup location selected. Click on the route or enter an address.',
    eventCode: 'Event code',
    copyEventCode: 'Copy',
    eventCodeCopied: 'Event code copied!',
    // Contact picker
    selectWhatsAppContact: '📱 Select who to contact',
    selectPhoneContact: '📞 Select who to call',
    mainDriver: 'Main Driver',
    // Share
    share: 'Share',
    copyLink: 'Copy Link',
    shareWhatsApp: 'WhatsApp',
    shareTelegram: 'Telegram',
    shareMore: 'More...',
    linkCopied: 'Link copied!',
    // Edit
    editOffer: 'Edit Ride Offer',
    editRequest: 'Edit Ride Request',
    saveChanges: 'Save Changes',
    updatedSuccessfully: 'Updated successfully!',
    // Compact cards
    free: 'Free',
    join: 'Join',
    tipWelcome: 'Tip Welcome',
    locationOnMap: 'Location',
    contactDriver: 'Contact Driver',
    organizers: 'Organizers',
    whatsappOnly: 'WhatsApp Only'
  },

  // Role Selection
  roleSelection: {
    title: 'Choose Your Role',
    subtitle: 'How would you like to participate?',
    driver: 'Driver',
    driverDescription: 'I have a car and want to offer rides',
    passenger: 'Passenger',
    passengerDescription: 'I need a ride and want to join someone',
    back: 'Back'
  },

  // Offer Carpool
  offerCarpool: {
    title: 'Offer a Carpool',
    subtitle: 'Share your ride with others',
    origin: 'Origin',
    destination: 'Destination',
    departureTime: 'Departure Time',
    flexibleTime: 'Flexible Time',
    specificTime: 'Specific Time',
    availableSeats: 'Available Seats',
    carpoolType: 'Carpool Type',
    public: 'Public',
    private: 'Private',
    publicDescription: 'Anyone can request to join',
    privateDescription: 'Only people you invite can join',
    additionalInfo: 'Additional Information',
    additionalInfoPlaceholder: 'Any additional details...',
    publish: 'Publish',
    cancel: 'Cancel',
    selectLocation: 'Select Location',
    enterLocation: 'Enter location',
    selectTime: 'Select Time',
    selectDate: 'Select Date'
  },

  // Need Carpool
  needCarpool: {
    title: 'Need a Carpool',
    subtitle: 'Find a ride to your destination',
    pickupLocation: 'Pickup Location',
    destination: 'Destination',
    preferredTime: 'Preferred Time',
    flexibleTime: 'Flexible Time',
    specificTime: 'Specific Time',
    numberOfPassengers: 'Number of Passengers',
    additionalInfo: 'Additional Information',
    additionalInfoPlaceholder: 'Any special requirements...',
    search: 'Search for Rides',
    cancel: 'Cancel',
    selectLocation: 'Select Location',
    enterLocation: 'Enter location',
    selectTime: 'Select Time',
    selectDate: 'Select Date'
  },

  // Driver Dashboard
  driverDashboard: {
    title: 'Driver Dashboard',
    myCarpool: 'My Carpool',
    requests: 'Requests',
    confirmed: 'Confirmed',
    pending: 'Pending',
    accepted: 'Accepted',
    rejected: 'Rejected',
    noRequests: 'No requests yet',
    accept: 'Accept',
    reject: 'Reject',
    viewDetails: 'View Details',
    editCarpool: 'Edit Carpool',
    deleteCarpool: 'Delete Carpool'
  },

  // Passenger Dashboard
  passengerDashboard: {
    title: 'Passenger Dashboard',
    myRequests: 'My Ride Requests',
    availableRides: 'Available Rides',
    pending: 'Pending',
    confirmed: 'Confirmed',
    rejected: 'Rejected',
    noRequests: 'No requests yet',
    requestRide: 'Request a Ride',
    viewDetails: 'View Details',
    cancelRequest: 'Cancel Request'
  },

  // My Account
  myAccount: {
    title: 'My Account',
    subtitle: 'Manage your events, rides & profile',
    personalInfo: 'Personal Information',
    name: 'Name',
    namePlaceholder: 'Your name',
    phone: 'Phone',
    email: 'Email',
    emailPlaceholder: 'your@email.com',
    gender: 'Gender',
    edit: 'Edit',
    save: 'Save',
    cancel: 'Cancel',
    accountSettings: 'Account Settings',
    loadingAccount: 'Loading your account...',
    profileUpdated: 'Profile updated successfully',
    failedToUpdate: 'Failed to update profile',
    failedToLoad: 'Failed to load your data',
    confirmDeleteOffer: 'Are you sure you want to delete this offer?',
    offerDeleted: 'Offer deleted successfully',
    failedToDeleteOffer: 'Failed to delete offer',
    confirmCancelRequest: 'Are you sure you want to cancel this request?',
    requestCancelled: 'Request cancelled',
    failedToCancelRequest: 'Failed to cancel request',
    confirmDeleteEvent: 'Are you sure you want to delete "{eventName}"?\n\nThis will remove all ride offers and requests for this event. This action cannot be undone.',
    eventDeleted: 'Event deleted successfully',
    failedToDeleteEvent: 'Failed to delete event',
    linkCopied: 'Link copied!',
    events: 'Events',
    rides: 'Rides',
    joined: 'Joined',
    seats: 'Seats',
    editProfile: 'Edit Profile',
    saveChanges: 'Save Changes',
    phoneCannotChange: 'Phone number cannot be changed',
    imDriving: 'I\'m Driving',
    imPassenger: 'I\'m a Passenger',
    pending: 'pending',
    noEventsYet: 'No Events Yet',
    createOrJoinEvent: 'Create an event or join one via a shared link.',
    createNewEvent: 'Create New Event',
    noRidesOffered: 'No Rides Offered',
    startDriving: 'You haven\'t offered any rides yet. Start driving to help others!',
    date: 'Date',
    available: 'available',
    trip: 'Trip',
    roundTrip: 'Round Trip',
    goingOnly: 'Going Only',
    returnOnly: 'Return Only',
    passengers: 'Passengers',
    confirmed: 'Confirmed',
    viewEvent: 'View Event',
    allStatus: 'All Status',
    allDates: 'All Dates',
    upcoming: 'Upcoming',
    noRidesFound: 'No Rides Found',
    adjustFilters: 'Try adjusting your filters.',
    noRidesAsPassenger: 'You haven\'t joined any rides as a passenger yet.',
    waiting: 'Waiting',
    driver: 'Driver',
    unknown: 'Unknown',
    contact: 'Contact',
    driverContactPending: 'Driver contact will show once confirmed',
    pickup: 'Pickup',
    destination: 'Destination',
    cancelRequest: 'Cancel Request',
    cancelRide: 'Cancel Ride',
    at: 'at',
    organizers: 'organizers',
    contactOrganizers: 'Contact Organizers',
    whatsappOnly: 'WhatsApp Only'
  },

  // My Rides
  myRides: {
    title: 'My Rides',
    subtitle: 'Manage your carpools and track ride requests',
    noRides: 'No rides yet',
    upcoming: 'Upcoming',
    past: 'Past',
    viewDetails: 'View Details',
    imDriving: 'I\'m Driving',
    imPassenger: 'I\'m a Passenger',
    noRidesOffered: 'No Rides Offered',
    shareYourCar: 'You haven\'t offered any rides yet. Share your car to help others get to events!',
    browseEvents: 'Browse Events',
    confirmed: 'Confirmed',
    noLocation: 'No location',
    pendingRequests: 'Pending Requests',
    accept: 'Accept',
    hideMap: 'Hide Map',
    showRoute: 'Show Route',
    viewEvent: 'View Event',
    noPassengersForMap: 'No confirmed passengers with locations to show on map.',
    allStatus: 'All Status',
    allDates: 'All Dates',
    noRidesFound: 'No Rides Found',
    browseEventsToFind: 'You haven\'t requested to join any rides yet. Browse events to find a carpool!',
    driver: 'Driver',
    contact: 'Contact',
    driverContactPending: 'Driver contact will be shown once confirmed',
    pickup: 'Pickup',
    event: 'Event',
    going: 'Going',
    return: 'Return',
    cancelRequest: 'Cancel Request',
    cancelRide: 'Cancel Ride',
    pending: 'Pending',
    rejected: 'Rejected',
    pleaseLogin: 'Please log in to accept requests',
    passengerConfirmed: 'Passenger confirmed!',
    failedToAccept: 'Failed to accept passenger',
    requestDeclined: 'Request declined',
    failedToDecline: 'Failed to decline request',
    confirmCancelRequest: 'Cancel this join request?',
    requestCancelled: 'Request cancelled',
    failedToCancelRequest: 'Failed to cancel request',
    confirmDeleteOffer: 'Are you sure you want to delete this ride offer? All passengers will be notified.',
    offerDeleted: 'Ride offer deleted',
    failedToDeleteOffer: 'Failed to delete offer',
    myRequests: 'My Ride Requests',
    date: 'Date',
    tripType: 'Trip Type',
    confirmCancelRideRequest: 'Are you sure you want to cancel this ride request?',
    rideRequestCancelled: 'Ride request cancelled',
    noRideRequests: 'No Ride Requests',
    createRideRequest: 'Create a request when you need a ride to an event',
    edit: 'Edit',
    editOffer: '✏️ Edit Ride Offer',
    editRequest: '✏️ Edit Ride Request',
    updateSuccess: 'Updated successfully!',
    updateFailed: 'Update failed',
    eventNotFound: 'Event not found',
    failedToCancelRideRequest: 'Failed to cancel ride request',
    myPosts: 'My Posts',
    noPosts: 'No posts yet',
    createPost: 'Publish a ride offer or request',
    myOffers: 'Ride Offers',
    rideOffer: 'Ride Offer',
    rideRequest: 'Ride Request',
    matched: 'Matched'
  },

  // Create Event
  createEvent: {
    title: 'Create Carpool Event',
    subtitle: 'Set up a carpool for your event and share the link with attendees',
    creatingAs: 'Creating as',
    youWillBeAdmin: 'You\'ll be the admin of this event',
    eventDetails: 'Event Details',
    eventName: 'Event Name',
    eventNamePlaceholder: 'e.g., Sarah\'s Birthday Party',
    date: 'Date',
    time: 'Time',
    startTime: 'Start Time',
    endTime: 'End Time (optional)',
    location: 'Location',
    eventLocation: 'Event Location',
    searchLocation: 'Search for event location...',
    privacy: 'Privacy',
    privateEvent: 'Private Event',
    publicEvent: 'Public Event',
    privateDescription: 'Only people with the access code can join',
    publicDescription: 'Anyone with the link can join',
    accessCode: 'Access Code',
    accessCodePlaceholder: 'e.g., PARTY2024',
    shareCodeHint: 'Share this code with your invited guests',
    eventType: 'Event Type',
    eventTypePlaceholder: 'Select type',
    eventTypeConcert: '🎵 Concert / Festival',
    eventTypeDemonstration: '🪧 Demonstration / Protest',
    eventTypeParty: '🎉 Party / Birthday',
    eventTypeConference: '🏫 Conference / Workshop',
    eventTypeSports: '⚽ Sports Event',
    eventTypeWedding: '👰 Wedding',
    eventTypeOther: '📌 Other',
    eventVibe: 'Event Vibe',
    eventVibeFun: '🎉 Fun & social',
    eventVibeChill: '😌 Chill',
    eventVibeHighEnergy: '🔥 High energy',
    eventVibeCalm: '🧘 Calm',
    eventVibePurpose: '✊ Purpose-driven',
    audienceSize: 'Expected audience size (estimate)',
    audienceSmall: '👥 Small (under 20)',
    audienceMedium: '👥 Medium (20–100)',
    audienceLarge: '👥 Large (100+)',
    aboutEvent: 'About the event',
    eventShortDescription: 'Short description (2 lines)',
    eventShortDescriptionPlaceholder: 'e.g. Open social gathering for everyone',
    eventNotes: 'Important notes (optional)',
    eventNotesPlaceholder: 'e.g. There may be traffic',
    isFeatured: 'Is this a featured event?',
    isFeaturedHint: 'e.g. First time event, New group, Recurring',
    eventImage: 'Event Image',
    uploadImage: 'Click to upload image',
    imageHint: 'Max 2MB, JPG/PNG',
    imageTooLarge: 'Image size too large. Maximum 2MB allowed.',
    invalidImageType: 'Please select a valid image file.',
    previewLabel: 'Preview',
    previewPlaceholder: 'Your event name',
    step1Title: 'What & when',
    step2Title: 'Where',
    step3Title: 'Who can join',
    createEventButton: 'Create Event & Get Link',
    creating: 'Creating...',
    creatingEvent: 'Creating your event...',
    backToHome: 'Back to Home',
    pleaseLogin: 'Please login to create an event',
    fillAllFields: 'Please fill in all required fields',
    setAccessCode: 'Please set an access code for your private event',
    sessionExpired: 'Session expired. Please login again.',
    failedToCreate: 'Failed to create event',
    tryAgain: 'Failed to create event. Please try again.',
    createdSuccessfully: 'Event created successfully!',
    eventCreated: 'Event Created!',
    shareLink: 'Share this link with your attendees',
    event: 'Event',
    when: 'When',
    at: 'at',
    where: 'Where',
    shareThisLink: 'Share this link:',
    copy: 'Copy',
    linkCopied: 'Link copied to clipboard!',
    manageEvent: 'Manage Event',
    goToEventPage: 'Go to Event Page',
    createAnother: 'Create Another Event',
    redirectingToLogin: 'Redirecting to login...'
  },

  // Admin
  admin: {
    login: 'Admin Login',
    dashboard: 'Admin Dashboard',
    events: 'Events',
    users: 'Users',
    statistics: 'Statistics',
    settings: 'Settings'
  },

  // Publish Ride
  publishRide: {
    offerRide: 'OFFER A RIDE',
    requestRide: 'REQUEST A RIDE',
    stepInfo: 'Info',
    stepLocation: 'Location',
    stepDetails: 'Details',
    stepTiming: 'Timing',
    loadingEvent: 'Loading event...',
    publishingRide: 'Publishing your ride...',
    sendingRequest: 'Sending your request...',
    pleaseWait: 'Please wait',
    yourInformation: 'Your Information',
    letOthersKnow: 'Let others know who you are',
    name: 'Name',
    namePlaceholder: 'Your full name',
    phone: 'Phone',
    phonePlaceholder: '+972 50-123-4567',
    email: 'Email',
    emailPlaceholder: 'your@email.com',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    yourLocation: 'Your Location',
    whereStartFrom: 'Where will you start from?',
    wherePickedUp: 'Where will you be picked up?',
    loadingMap: 'Loading map...',
    searchLocation: 'Search for your location...',
    calculatingRoute: 'Calculating route...',
    tripDetails: 'Trip Details',
    configurePreferences: 'Configure your ride preferences',
    tripDirection: 'Trip Direction',
    going: 'Going',
    return: 'Return',
    both: 'Both',
    bothDifferent: 'Both (different locations)',
    vehicleType: 'Vehicle Type',
    car: 'Car',
    publicVehicle: 'Public Vehicle',
    goingLocation: 'Going Location (Pickup)',
    returnLocation: 'Return Location (Drop-off)',
    searchReturnLocation: 'Search return location...',
    returnTime: 'Return Time',
    flexible: 'Flexible',
    dropOffDifferent: 'Drop off is different',
    timeAndSeats: 'Time & Seats',
    pickupLocations: 'Pickup Locations',
    dropoffLocations: 'Drop-off Locations',
    pickupLocation: 'Pickup location',
    dropoffLocation: 'Drop-off location',
    addPickupLocation: 'Add Pickup Location',
    addDropoffLocation: 'Add Drop-off Location',
    allowCustomPickup: 'Allow passengers to request custom pickup location',
    arrivalTime: 'Preferred Arrival Time',
    eventTime: 'Event',
    availableSeats: 'Available Seats',
    passengers: 'Passengers',
    passengerPreference: 'Passenger Preference',
    anyone: 'Anyone',
    men: 'Men',
    women: 'Women',
    payment: 'Payment',
    setPaymentPreferences: 'Set your payment preferences',
    freeRide: 'Free Ride',
    tipWelcome: 'Tip Welcome',
    required: 'Required',
    amount: 'Amount',
    suggestedMax: 'Suggested max',
    paymentMethod: 'Payment Method',
    cash: 'Cash',
    bit: 'Bit',
    paybox: 'PayBox',
    additionalNotes: 'Additional Notes',
    anythingElse: 'Anything else to share?',
    notesPlaceholderOffer: 'Car model, music preferences, meeting point...',
    notesPlaceholderRequest: 'Special requests, flexibility with timing...',
    publishRide: 'Publish Ride',
    sendRequest: 'Send Request',
    welcomeBack: 'Welcome back! Login code sent.',
    codeSent: 'Verification code sent!',
    failedToSendOTP: 'Failed to send OTP',
    enter6DigitOTP: 'Please enter 6-digit OTP',
    verifiedSuccess: 'Verified successfully!',
    invalidOTP: 'Invalid OTP',
    ridePublished: '🎉 Ride published!',
    requestSent: '🎉 Request sent!',
    failedToPublish: 'Failed to publish',
    fillRequiredFields: 'Please fill in all required fields',
    selectPickupLocation: 'Please select your pickup location',
    enterEmail: 'Please enter your email',
    sendingCode: 'Sending Verification Code',
    sendingCodeTo: 'We\'re sending a code to',
    createAccount: 'Create Account',
    welcomeBackTitle: 'Welcome Back!',
    enterCodeToCreate: 'Enter code to create your account',
    enterCodeToLogin: 'You already have an account. Enter code to login.',
    sending: 'Sending...',
    resendCode: 'Resend Code',
    verifying: 'Verifying...',
    verifyAndPublish: 'Verify & Publish',
    // Bus route stops
    pickupStops: 'Pickup Locations',
    pickupStopsDesc: 'Add stops where you\'ll pick up passengers',
    dropoffStops: 'Drop-off Locations',
    dropoffStopsDesc: 'Add stops where you\'ll drop off passengers after the event',
    searchStopLocation: 'Search for a location...',
    stopNickname: 'Location Name',
    stopNicknamePlaceholder: 'e.g., Central Station, Main Square',
    stopTime: 'Pickup Time',
    addPickupStop: 'Add Another Pickup Location',
    addDropoffStop: 'Add Another Drop-off Location',
    removeStop: 'Remove This Stop',
    autoGeneratedReturn: 'Return stops auto-generated from pickup route. You can edit them below.',
    nearbyOffersFound: 'Nearby Rides Found!',
    nearbyOffersDesc: 'We found some rides near your location. You can join one of these instead of creating a new request:',
    seatsAvailable: 'seats',
    viewOffer: 'View Offer',
    createRequestAnyway: 'Create Request Anyway',
    // Vehicle type and organizers
    selectVehicleType: 'Select vehicle type',
    additionalOrganizers: 'Additional Organizers',
    addOrganizersHint: 'Click + to add additional organizers who can be contacted',
    organizerName: 'Organizer Name',
    organizerPhone: 'Phone Number',
    hidePhone: 'Hide my phone number until accepted',
    disableJoinRequest: 'WhatsApp Contact Only',
    disableJoinRequestHint: 'Remove "Request to Join" button - passengers can only contact you via WhatsApp',
    editOffer: 'Edit Ride Offer',
    editRequest: 'Edit Ride Request',
    updateRide: 'Update',
    updateSuccess: 'Updated successfully!',
    updateFailed: 'Update failed'
  },

  // Demonstrations
  demonstrations: {
    heroTitle: 'Ride Together. <br> Show Up Together.',
    heroSubtitle: 'Safer, smarter coordination for demonstrations — carpool with people you trust, reduce friction, and get there on time.',
    note: 'Trempi supports safety and community care. Use responsibly, follow local laws, and prioritize privacy.',
    chipSafety: 'Safety-first coordination',
    chipCost: 'Reduce costs',
    chipCommunity: 'Move as a community',
    joinTitle: 'Join a Demonstration',
    codePlaceholder: 'Enter demonstration code',
    joinButton: 'Join Route',
    helperText: 'Got a code from an organizer? Join the carpool route for that demonstration.',
    pleaseEnterCode: 'Please enter a demonstration code',
    invalidCode: 'Invalid demonstration code. Please try again.',
    eventFound: 'Demonstration found!',
    cardOrganizeTitle: 'Organize a Demonstration',
    cardOrganizeSubtitle: 'Create a coordination hub & share a code with your group.',
    cardOfferTitle: 'Offer a Ride',
    cardOfferSubtitle: 'Share your seats with people heading to the same location.',
    cardRequestTitle: 'Request a Ride',
    cardRequestSubtitle: 'Ask for a seat and match with drivers going your way.',
    safetyHeading: 'Before you go',
    safetyItem1: 'Share pickup points only with trusted participants',
    safetyItem2: 'Keep personal details minimal',
    safetyItem3: 'Agree on a meeting point and backup plan',
    safetyItem4: 'If anything feels unsafe, cancel and regroup',
    footerText: 'Already have an account?',
    footerButton: 'Login / Sign Up',
    // Create Demonstration
    createTitle: 'Create Demonstration',
    createSubtitle: 'Set up a coordination hub for your demonstration and share the code with participants',
    detailsTitle: 'Demonstration Details',
    nameLabel: 'Demonstration Name',
    namePlaceholder: 'e.g., Peace March - Tel Aviv',
    locationTitle: 'Location',
    locationLabel: 'Demonstration Location',
    searchLocation: 'Search for demonstration location...',
    privacyTitle: 'Privacy',
    creating: 'Creating...',
    createButton: 'Create Demonstration & Get Code',
    created: 'Demonstration Created!',
    shareLink: 'Share this code with participants to coordinate carpools',
    demonstration: 'Demonstration',
    manage: 'Manage Demonstration',
    goToPage: 'Go to Demonstration Page',
    createAnother: 'Create Another Demonstration',
    backToHome: 'Back to Demonstrations',
    alwaysPublic: 'Demonstrations are always public',
    publicNote: 'All demonstrations are visible to everyone on the platform.'
  }
};

// Arabic translations
export const ar = {
  // Common
  common: {
    loading: 'جاري التحميل...',
    error: 'خطأ',
    success: 'نجاح',
    cancel: 'إلغاء',
    confirm: 'تأكيد',
    save: 'حفظ',
    delete: 'حذف',
    edit: 'تعديل',
    close: 'إغلاق',
    back: 'رجوع',
    next: 'التالي',
    submit: 'إرسال',
    search: 'بحث',
    filter: 'تصفية',
    clear: 'مسح',
    yes: 'نعم',
    no: 'لا',
    ok: 'موافق',
    optional: 'اختياري',
    saving: 'جاري الحفظ...'
  },

  // Header
  header: {
    myEvents: 'أحداثي',
    myRides: 'رحلاتي',
    account: 'الحساب',
    logout: 'تسجيل الخروج',
    loginSignUp: 'تسجيل الدخول / إنشاء حساب',
    createEvent: 'إنشاء حدث',
    home: 'الرئيسية'
  },

  // Event Code Entry
  eventCode: {
    title: 'مرحباً بعودتك،',
    subtitle: 'ماذا تريد أن تفعل اليوم؟',
    joinEvent: 'الانضمام للحدث',
    enterEventCode: 'أدخل رمز الحدث',
    eventCodePlaceholder: 'أدخل رمز الحدث',
    joinButton: 'انضم',
    myEvents: 'أحداثي',
    noEvents: 'لا توجد أحداث بعد',
    createNewEvent: 'إنشاء حدث جديد',
    invalidCode: 'رمز الحدث غير صحيح. يرجى المحاولة مرة أخرى.',
    pleaseEnterCode: 'يرجى إدخال رمز الحدث',
    eventFound: 'تم العثور على الحدث!',
    loggedOut: 'تم تسجيل الخروج بنجاح',
    createEventDesc: 'تنظيم حدث جديد',
    offerRide: 'عرض تريمب',
    shareCar: 'شارك سيارتك',
    findRide: 'العثور على رحلة',
    requestSeat: 'طلب مقعد',
    viewAll: 'عرض الكل',
    alreadyHaveAccount: 'هل لديك حساب بالفعل؟'
  },

  // Login
  login: {
    title: 'مرحباً بك في تريمبي',
    subtitle: 'أدخل رقم هاتفك للبدء',
    phoneNumber: 'رقم الهاتف',
    phonePlaceholder: 'أدخل رقم هاتفك',
    sendOTP: 'إرسال رمز التحقق',
    enterOTP: 'أدخل الرمز المكون من 6 أرقام الذي أرسلناه لك',
    otpPlaceholder: 'أدخل الرمز المكون من 6 أرقام',
    verify: 'تحقق',
    resendOTP: 'إعادة إرسال رمز التحقق',
    resendIn: 'إعادة الإرسال خلال',
    seconds: 'ث',
    completeRegistration: 'إكمال التسجيل',
    name: 'الاسم الكامل',
    namePlaceholder: 'أدخل اسمك الكامل',
    email: 'البريد الإلكتروني',
    emailPlaceholder: 'أدخل بريدك الإلكتروني',
    gender: 'الجنس',
    genderMale: 'ذكر',
    genderFemale: 'أنثى',
    genderOther: 'آخر',
    hidePhone: 'إخفاء رقم هاتفي',
    hidePhoneHint: 'يمكن للآخرين الاتصال بك فقط بعد الموافقة على طلبهم',
    register: 'إنشاء حساب',
    welcome: 'مرحباً',
    invalidOTP: 'رمز التحقق غير صحيح',
    pleaseCompleteRegistration: 'يرجى إكمال التسجيل',
    createAccount: 'إنشاء حساب',
    invalidPhone: 'يرجى إدخال رقم هاتف صحيح مكون من 10 أرقام يبدأ بـ 0',
    fillDetails: 'يرجى ملء بياناتك لإنشاء حساب',
    codeSent: 'تم إرسال الرمز! رمز التحقق الخاص بك هو:',
    welcomeBack: 'مرحباً بعودتك! تم إرسال رمز تسجيل الدخول.',
    failedToSendOTP: 'فشل إرسال رمز التحقق',
    otpAlreadySent: 'تم إرسال رمز التحقق بالفعل. يرجى إدخاله أدناه.',
    enter6DigitOTP: 'يرجى إدخال رمز التحقق المكون من 6 أرقام',
    pleaseEnterName: 'يرجى إدخال اسمك',
    pleaseEnterValidEmail: 'يرجى إدخال بريد إلكتروني صحيح',
    pleaseSelectGender: 'يرجى اختيار جنسك',
    verificationCodeSent: 'تم إرسال رمز التحقق!',
    codeResent: 'تم إعادة إرسال الرمز! رمز التحقق الخاص بك هو:',
    otpResent: 'تم إعادة إرسال رمز التحقق إلى هاتفك',
    failedToResendOTP: 'فشل إعادة إرسال رمز التحقق',
    sending: 'جاري الإرسال...',
    sendingOTP: 'جاري إرسال رمز التحقق...',
    verifying: 'جاري التحقق...',
    codeSentTo: 'تم إرسال الرمز إلى',
    termsOfService: 'بالمتابعة، أنت توافق على شروط الخدمة الخاصة بنا',
    smsHint: 'سنرسل لك رمز التحقق عبر الرسائل النصية'
  },

  // Landing Page
  landing: {
    heroTitle: 'اركب معاً، وفر معاً',
    heroSubtitle: 'تواصل مع المسافرين الآخرين، قلل التكاليف، واجعل تنقلاتك أكثر متعة.',
    getStarted: 'ابدأ الآن',
    learnMore: 'اعرف المزيد',
    connectNetwork: 'تواصل وبناء شبكة',
    connectDescription: 'تعرف على أشخاص رائعين في تنقلاتك اليومية. ابني علاقات ذات معنى ووسع شبكتك المهنية أثناء مشاركة الرحلات.',
    connectionsMade: 'اتصال تم إنشاؤه',
    saveFuel: 'وفر الوقود',
    saveDescription: 'قلل تكاليف النقل بنسبة تصل إلى 75%. شارك المصاريف مع المسافرين الآخرين واحتفظ بمزيد من المال في جيبك.',
    savedCollectively: 'تم توفيره بشكل جماعي',
    ecoFriendly: 'صديق للبيئة',
    ecoDescription: 'قلل بصمتك الكربونية وساهم في كوكب أكثر اخضراراً. كل رحلة مشتركة تحدث فرقاً.',
    co2Reduced: 'تم تقليل ثاني أكسيد الكربون',
    howItWorks: 'كيف يعمل',
    step1Title: 'أدخل رمز الحدث',
    step1Description: 'احصل على رمز الحدث الفريد من المنظم وأدخله للانضمام إلى شبكة المشاركة.',
    step2Title: 'اختر دورك',
    step2Description: 'قرر ما إذا كنت تريد عرض تريمب كسائق أو بدور عتريمب كراكب.',
    step3Title: 'تواصل واركب',
    step3Description: 'تطابق مع المسافرين المتوافقين، أكد رحلتك، واستمتع بالرحلة معاً!',
    testimonials: 'ماذا يقول مستخدمونا',
    getStartedNow: 'ابدأ الآن',
    readyToStart: 'هل أنت مستعد لبدء رحلتك في المشاركة؟'
  },

  // Homepage (EventCodeEntry / landing)
  homepage: {
    welcomeName: 'أهلاً', // show "أهلاً، {firstName}" when logged in
    heroTag: 'رحلات أذكى لأحداث أفضل',
    heroTitleLine1: 'حدثك.',
    heroTitleLine2: 'مجتمعك.',
    heroTitleLine3: 'رحلة واحدة في كل مرة.',
    heroSubtitle: 'حوّل كل رحلة إلى فرصة. تواصل مع الحضور، شارك التجارب، ووصلوا معاً. التواصل يبدأ قبل الوصول.',
    eventCodePlaceholder: 'أدخل رمز الحدث أو الرابط',
    join: 'انضم',
    offerRide: 'عرض تريمب',
    requestRide: 'طلب تريمب',
    offerTremp: 'عرض تريمب',
    requestTremp: 'طلب تريمب',
    previewEventTitle: 'زفاف - مهدي وسارة',
    previewRidesCount: '٦ رحلات',
    rideRouteSample1: 'تل أبيب ← حيفا • المغادرة ٤:٣٠ م',
    rideRouteSample2: 'القدس ← حيفا • المغادرة ٣:٠٠ م',
    latestEventsTag: 'أحدث الأحداث',
    discoverEvents: 'اكتشف الأحداث',
    discoverSubtitle: 'انضم لأحداث ممتعة وتواصل مع الحضور',
    searchPlaceholder: 'ابحث بالأحداث بالاسم، الموقع أو الرمز...',
    noEventsFound: 'لم يتم العثور على أحداث تطابق',
    featuresTag: 'المميزات',
    everythingYouNeed: 'كل ما تحتاجه',
    featuresSubtitle: 'مميزات قوية لجعل المشاركة بسيطة',
    impactTag: 'التأثير',
    betterForEveryone: 'أفضل للجميع',
    impactSubtitle: 'المشاركة ليست مريحة فقط – إنها خيار يفيدك ومجتمعك والكوكب.',
    ctaTitle: 'مستعد للركوب معاً؟',
    ctaSubtitle: 'انضم لمجتمع الحضور الذين اكتشفوا أن الرحلة بنفس أهمية الوصول.',
    createEventBtn: 'إنشاء حدث',
    joinEventBtn: 'انضم للحدث',
    eventCodeCopied: 'تم نسخ رمز الحدث!',
    featureEventCentric: 'مركزي على الحدث',
    featureEventCentricDesc: 'مصمم خصيصاً للأحداث. أعراس، مؤتمرات، لقاءات – تنسيق الرحلات في مكان واحد.',
    featureTrustFirst: 'الثقة أولاً',
    featureTrustFirstDesc: 'شارك الرحلات مع من يحضرون نفس الحدث. الاهتمام المشترك يبني ثقة فورية.',
    featureConnectInstantly: 'تواصل فوري',
    featureConnectInstantlyDesc: 'رسائل ومكالمات واتساب بنقرة واحدة. تنسيق نقاط الالتقاء بسهولة.',
    featureSmartMatching: 'تطابق ذكي',
    featureSmartMatchingDesc: 'خوارزميتنا تطابق السائقين والراكبين على أفضل المسارات.',
    featurePrivacyControls: 'التحكم بالخصوصية',
    featurePrivacyControlsDesc: 'شارك فقط ما تريد. أخفِ رقمك أو بريدك أو اسمك عن الآخرين.',
    featureNoAppNeeded: 'بدون تطبيق',
    featureNoAppNeededDesc: 'يعمل في أي متصفح. شارك الرابط وينضم الجميع فوراً.',
    savingsLabel: 'متوسط التوفير على تكاليف السفر',
    fewerCarsLabel: 'سيارات أقل في مواقع الأحداث',
    co2SavedLabel: 'ثاني أكسيد كربون موفر في كل رحلة مشتركة',
    connectionsLabel: 'اتصالات في انتظار الحدوث',
    heroTitle: 'شارك الرحلة إلى حدثك — معاً.',
    createEvent: 'إنشاء حدث',
    joinWithCode: 'انضم برمز',
    enterEventCode: 'أدخل رمز الحدث',
    pasteHelper: 'الصق الرمز الذي استلمته (مثال: ',
    goToEvent: 'انتقل للحدث',
    findingEvent: 'جاري البحث عن الحدث...',
    pleaseEnterCode: 'يرجى إدخال رمز الحدث',
    invalidFormat: 'صيغة رمز غير صالحة. استخدم حروفاً أو أرقاماً أو شرطة فقط.',
    eventNotFound: 'الحدث غير موجود. تحقق من الرمز وحاول مرة أخرى.',
    recentEvents: 'أحدث الأحداث',
    howItWorksTitle: 'كيف يعمل',
    howItWorksSubtitle: 'يعمل خلال دقائق',
    howItWorksDescription: 'بدون إعداد معقد. بدون تحميل تطبيق. فقط أنشئ، شارك، وانطلق.',
    step1Title: 'إنشاء حدث',
    step1Description: 'أعد حدثك بالتاريخ والوقت والموقع في ثوانٍ.',
    step2Title: 'شارك الرابط',
    step2Description: 'أرسل الرابط الفريد لجميع الحضور عبر أي تطبيق مراسلة.',
    step3Title: 'عرض أو طلب',
    step3Description: 'السائقون يعرضون المقاعد، الركاب يطلبون رحلات حسب المسارات.',
    step4Title: 'تطابق وانطلق',
    step4Description: 'تواصل، نسّق نقطة الالتقاء، وسافروا معاً!',
    impactTitle: 'التأثير',
    impactDescription: 'المشاركة ليست مريحة فقط – إنها خيار يفيدك ومجتمعك والكوكب.',
    networkingTitle: 'التواصل',
    networkingSubtitle: 'التواصل يبدأ في سيارتك',
    networkingDescription: 'أفضل الاتصالات تحدث في أماكن غير متوقعة. رحلة ٤٥ دقيقة مع مشارك يمكن أن تؤدي لشراكات وصداقات وفرص.',
    connectionMade: 'اتصال تم قبل ٤٥ دقيقة من الحدث',
    sharedInterestsTitle: 'اهتمامات مشتركة',
    sharedInterestsDescription: 'أنتم ذاهبون لنفس المكان. أرضية مشتركة مضمونة.',
    uninterruptedTimeTitle: 'وقت دون انقطاع',
    uninterruptedTimeDescription: 'بدون زحام أو ضجيج. محادثات حقيقية تصل لمكان ما.',
    warmIntrosTitle: 'تعارف دافئ',
    warmIntrosDescription: 'وصلوا معاً ويكون لديكم من يقدمكم للآخرين.',
    safetyTitle: 'الثقة والأمان',
    safetySubtitle: 'اركب مع من تثق بهم',
    safetyDescription: 'عندما الجميع ذاهبون لنفس الحدث، لديكم بالفعل قاسم مشترك. هذا السياق يخلق ثقة فورية ومحادثات أفضل.',
    mutualConnectionsTitle: 'اتصالات مشتركة',
    mutualConnectionsDescription: 'شاهد الأصدقاء والاتصالات المشتركة قبل الركوب.',
    ratingsTitle: 'تقييمات ومراجعات السائقين',
    ratingsDescription: 'تعليقات حقيقية من ركاب حقيقيين.',
    verifiedTitle: 'ملفات موثقة',
    verifiedDescription: 'التحقق بالهاتف يضمن أن الجميع هم من يقولون.',
  },

  // Event Dashboard
  eventDashboard: {
    home: 'الرئيسية',
    myRides: 'رحلاتي',
    eventTitle: 'الحدث',
    publishRide: 'نشر رحلة',
    findRide: 'العثور على رحلة',
    adminPanel: 'لوحة الإدارة',
    availableRides: 'الرحلات المتاحة',
    myRide: 'رحلتي',
    noRidesAvailable: 'لا توجد رحلات متاحة بعد',
    beFirst: 'كن أول من ينشر رحلة!',
    loadingRides: 'جاري تحميل الرحلات...',
    errorLoadingRides: 'خطأ في تحميل الرحلات',
    offerRide: 'عرض تريمب',
    requestRide: 'طلب تريمب',
    needRide: 'بدور عتريمب',
    ridesAvailable: 'عروض',
    ridesNeeded: 'طلبات',
    joined: 'انضم',
    myConfirmedRides: 'رحلاتي المؤكدة',
    ridingWith: 'الركوب مع',
    pickup: 'موقع الاستلام',
    destination: 'الوجهة',
    call: 'اتصال',
    whatsapp: 'واتساب',
    showing: 'عرض',
    of: 'من',
    rides: 'رحلات',
    clearFilters: 'مسح الفلاتر',
    filterRides: 'تصفية الرحلات',
    narrowResults: 'ضيّق حسب نوع الرحلة، المقاعد، الدفع والمزيد',
    noRidesMatchFilters: 'لا توجد رحلات تطابق فلاترك',
    adjustFilters: 'حاول تعديل فلاترك لرؤية المزيد من الرحلات',
    noRidesOffered: 'لا توجد رحلات معروضة بعد',
    beFirstToOffer: 'كن أول من يقدم رحلة لهذا الحدث!',
    myOffer: 'عرضي',
    full: 'ممتلئ',
    seats: 'مقاعد',
    driver: 'سائق',
    confirmed: 'مؤكد',
    manage: 'إدارة',
    requests: 'الطلبات',
    requestToJoin: 'طلب الانضمام',
    going: 'ذهاب',
    return: 'عودة',
    startingFrom: 'بدءاً من',
    arriving: 'الوصول',
    dropoff: 'النزول',
    stops: 'محطات',
    selectPickup: 'اختر موقع الإقلاع',
    selectDropoff: 'اختر موقع النزول',
    choosePickup: '-- اختر نقطة الإقلاع --',
    chooseDropoff: '-- اختر نقطة النزول --',
    enterCustomLocation: 'أدخل موقع مخصص...',
    eventCode: 'رمز الحدث',
    copyEventCode: 'نسخ',
    eventCodeCopied: 'تم نسخ رمز الحدث!',
    customPickup: 'موقع إقلاع مخصص',
    enterAddress: 'أدخل عنوانك...',
    selectedLocations: 'المواقع المختارة',
    choosePickupOnRoute: 'اختر موقع الإقلاع على المسار',
    enterAddressManually: 'أدخل العنوان يدوياً',
    enterPickupAddress: 'أدخل عنوان الإقلاع...',
    orSelectOnMap: 'أو اختر على الخريطة',
    pickupSelected: 'تم اختيار موقع الإقلاع',
    noPickupSelected: 'لم يتم اختيار موقع الإقلاع. انقر على المسار أو أدخل عنواناً.',
    // Contact picker
    selectWhatsAppContact: '📱 اختر من تريد التواصل معه',
    selectPhoneContact: '📞 اختر من تريد الاتصال به',
    mainDriver: 'السائق الرئيسي',
    matchesYourRequest: 'يطابق طلبك!',
    // Share
    share: 'مشاركة',
    copyLink: 'نسخ الرابط',
    shareWhatsApp: 'واتساب',
    shareTelegram: 'تيليجرام',
    shareMore: 'المزيد...',
    linkCopied: 'تم نسخ الرابط!',
    // Edit
    editOffer: 'تعديل العرض',
    editRequest: 'تعديل الطلب',
    saveChanges: 'حفظ التغييرات',
    updatedSuccessfully: 'تم التحديث بنجاح!',
    // Compact cards
    free: 'مجاني',
    join: 'انضم',
    tipWelcome: 'البقشيش مرحب',
    locationOnMap: 'موقع',
    contactDriver: 'تواصل مع السائق',
    organizers: 'المنظمون',
    whatsappOnly: 'واتساب فقط'
  },

  // Role Selection
  roleSelection: {
    title: 'اختر دورك',
    subtitle: 'كيف تريد المشاركة؟',
    driver: 'سائق',
    driverDescription: 'لدي سيارة وأريد تقديم رحلات',
    passenger: 'راكب',
    passengerDescription: 'أحتاج إلى رحلة وأريد الانضمام إلى شخص ما',
    back: 'رجوع'
  },

  // Offer Carpool
  offerCarpool: {
    title: 'تقديم مشاركة',
    subtitle: 'شارك رحلتك مع الآخرين',
    origin: 'نقطة الانطلاق',
    destination: 'الوجهة',
    departureTime: 'وقت المغادرة',
    flexibleTime: 'وقت مرن',
    specificTime: 'وقت محدد',
    availableSeats: 'المقاعد المتاحة',
    carpoolType: 'نوع المشاركة',
    public: 'عام',
    private: 'خاص',
    publicDescription: 'يمكن لأي شخص طلب الانضمام',
    privateDescription: 'فقط الأشخاص الذين تدعوهم يمكنهم الانضمام',
    additionalInfo: 'معلومات إضافية',
    additionalInfoPlaceholder: 'أي تفاصيل إضافية...',
    publish: 'نشر',
    cancel: 'إلغاء',
    selectLocation: 'اختر الموقع',
    enterLocation: 'أدخل الموقع',
    selectTime: 'اختر الوقت',
    selectDate: 'اختر التاريخ'
  },

  // Need Carpool
  needCarpool: {
    title: 'أحتاج إلى مشاركة',
    subtitle: 'ابحث عن رحلة إلى وجهتك',
    pickupLocation: 'موقع الاستلام',
    destination: 'الوجهة',
    preferredTime: 'الوقت المفضل',
    flexibleTime: 'وقت مرن',
    specificTime: 'وقت محدد',
    numberOfPassengers: 'عدد الركاب',
    additionalInfo: 'معلومات إضافية',
    additionalInfoPlaceholder: 'أي متطلبات خاصة...',
    search: 'البحث عن رحلات',
    cancel: 'إلغاء',
    selectLocation: 'اختر الموقع',
    enterLocation: 'أدخل الموقع',
    selectTime: 'اختر الوقت',
    selectDate: 'اختر التاريخ'
  },

  // Driver Dashboard
  driverDashboard: {
    title: 'لوحة تحكم السائق',
    myCarpool: 'مشاركتي',
    requests: 'الطلبات',
    confirmed: 'مؤكد',
    pending: 'قيد الانتظار',
    accepted: 'مقبول',
    rejected: 'مرفوض',
    noRequests: 'لا توجد طلبات بعد',
    accept: 'قبول',
    reject: 'رفض',
    viewDetails: 'عرض التفاصيل',
    editCarpool: 'تعديل المشاركة',
    deleteCarpool: 'حذف المشاركة'
  },

  // Passenger Dashboard
  passengerDashboard: {
    title: 'لوحة تحكم الراكب',
    myRequests: 'طلباتي',
    availableRides: 'الرحلات المتاحة',
    pending: 'قيد الانتظار',
    confirmed: 'مؤكد',
    rejected: 'مرفوض',
    noRequests: 'لا توجد طلبات بعد',
    requestRide: 'بدور عتريمب',
    viewDetails: 'عرض التفاصيل',
    cancelRequest: 'إلغاء الطلب'
  },

  // My Account
  myAccount: {
    title: 'حسابي',
    subtitle: 'إدارة أحداثك ورحلاتك وملفك الشخصي',
    personalInfo: 'المعلومات الشخصية',
    name: 'الاسم',
    namePlaceholder: 'اسمك',
    phone: 'الهاتف',
    email: 'البريد الإلكتروني',
    emailPlaceholder: 'بريدك@الإلكتروني.com',
    gender: 'الجنس',
    edit: 'تعديل',
    save: 'حفظ',
    cancel: 'إلغاء',
    accountSettings: 'إعدادات الحساب',
    loadingAccount: 'جاري تحميل حسابك...',
    profileUpdated: 'تم تحديث الملف الشخصي بنجاح',
    failedToUpdate: 'فشل تحديث الملف الشخصي',
    failedToLoad: 'فشل تحميل بياناتك',
    confirmDeleteOffer: 'هل أنت متأكد أنك تريد حذف هذا العرض؟',
    offerDeleted: 'تم حذف العرض بنجاح',
    failedToDeleteOffer: 'فشل حذف العرض',
    confirmCancelRequest: 'هل أنت متأكد أنك تريد إلغاء هذا الطلب؟',
    requestCancelled: 'تم إلغاء الطلب',
    failedToCancelRequest: 'فشل إلغاء الطلب',
    confirmDeleteEvent: 'هل أنت متأكد أنك تريد حذف "{eventName}"؟\n\nسيؤدي هذا إلى إزالة جميع عروض الرحلات والطلبات لهذا الحدث. لا يمكن التراجع عن هذا الإجراء.',
    eventDeleted: 'تم حذف الحدث بنجاح',
    failedToDeleteEvent: 'فشل حذف الحدث',
    linkCopied: 'تم نسخ الرابط!',
    events: 'الأحداث',
    rides: 'الرحلات',
    joined: 'انضم',
    seats: 'المقاعد',
    editProfile: 'تعديل الملف الشخصي',
    saveChanges: 'حفظ التغييرات',
    phoneCannotChange: 'لا يمكن تغيير رقم الهاتف',
    imDriving: 'أنا سايق',
    imPassenger: 'أنا راكب',
    pending: 'قيد الانتظار',
    noEventsYet: 'لا توجد أحداث بعد',
    createOrJoinEvent: 'قم بإنشاء حدث أو انضم إلى واحد عبر رابط مشترك.',
    createNewEvent: 'إنشاء حدث جديد',
    noRidesOffered: 'لا توجد رحلات معروضة',
    startDriving: 'لم تقدم أي رحلات بعد. ابدأ القيادة لمساعدة الآخرين!',
    date: 'التاريخ',
    available: 'متاح',
    trip: 'الرحلة',
    roundTrip: 'ذهاب وعودة',
    goingOnly: 'ذهاب فقط',
    returnOnly: 'عودة فقط',
    passengers: 'الركاب',
    confirmed: 'مؤكد',
    viewEvent: 'عرض الحدث',
    allStatus: 'جميع الحالات',
    allDates: 'جميع التواريخ',
    upcoming: 'القادمة',
    noRidesFound: 'لا توجد رحلات',
    adjustFilters: 'حاول تعديل فلاترك.',
    noRidesAsPassenger: 'لم تنضم إلى أي رحلات كراكب بعد.',
    waiting: 'في الانتظار',
    driver: 'السائق',
    unknown: 'غير معروف',
    contact: 'جهة الاتصال',
    driverContactPending: 'سيظهر اتصال السائق بمجرد التأكيد',
    pickup: 'موقع الاستلام',
    destination: 'الوجهة',
    cancelRequest: 'إلغاء الطلب',
    cancelRide: 'إلغاء الرحلة',
    at: 'في',
    organizers: 'منظمين',
    contactOrganizers: 'التواصل مع المنظمين',
    whatsappOnly: 'واتساب فقط'
  },

  // My Rides
  myRides: {
    title: 'رحلاتي',
    subtitle: 'إدارة مشاركاتك وتتبع طلبات الرحلات',
    noRides: 'لا توجد رحلات بعد',
    upcoming: 'القادمة',
    past: 'السابقة',
    viewDetails: 'عرض التفاصيل',
    imDriving: 'أنا سايق',
    imPassenger: 'أنا راكب',
    noRidesOffered: 'لا توجد رحلات معروضة',
    shareYourCar: 'لم تقدم أي رحلات بعد. شارك سيارتك لمساعدة الآخرين للوصول إلى الأحداث!',
    browseEvents: 'تصفح الأحداث',
    confirmed: 'مؤكد',
    noLocation: 'لا يوجد موقع',
    pendingRequests: 'الطلبات المعلقة',
    accept: 'قبول',
    hideMap: 'إخفاء الخريطة',
    showRoute: 'عرض المسار',
    viewEvent: 'عرض الحدث',
    noPassengersForMap: 'لا يوجد ركاب مؤكدون بمواقع لعرضها على الخريطة.',
    allStatus: 'جميع الحالات',
    allDates: 'جميع التواريخ',
    noRidesFound: 'لا توجد رحلات',
    browseEventsToFind: 'لم تطلب الانضمام إلى أي رحلات بعد. تصفح الأحداث للعثور على مشاركة!',
    driver: 'السائق',
    contact: 'جهة الاتصال',
    driverContactPending: 'سيظهر اتصال السائق بمجرد التأكيد',
    pickup: 'موقع الاستلام',
    event: 'الحدث',
    going: 'ذهاب',
    return: 'عودة',
    cancelRequest: 'إلغاء الطلب',
    cancelRide: 'إلغاء الرحلة',
    pending: 'قيد الانتظار',
    rejected: 'مرفوض',
    pleaseLogin: 'يرجى تسجيل الدخول لقبول الطلبات',
    passengerConfirmed: 'تم تأكيد الراكب!',
    failedToAccept: 'فشل قبول الراكب',
    requestDeclined: 'تم رفض الطلب',
    failedToDecline: 'فشل رفض الطلب',
    confirmCancelRequest: 'إلغاء طلب الانضمام هذا؟',
    requestCancelled: 'تم إلغاء الطلب',
    failedToCancelRequest: 'فشل إلغاء الطلب',
    confirmDeleteOffer: 'هل أنت متأكد أنك تريد حذف عرض الرحلة هذا؟ سيتم إشعار جميع الركاب.',
    offerDeleted: 'تم حذف عرض الرحلة',
    failedToDeleteOffer: 'فشل حذف العرض',
    myRequests: 'طلبات رحلاتي',
    date: 'التاريخ',
    tripType: 'نوع الرحلة',
    confirmCancelRideRequest: 'هل أنت متأكد أنك تريد إلغاء طلب الرحلة هذا؟',
    rideRequestCancelled: 'تم إلغاء طلب الرحلة',
    noRideRequests: 'لا توجد طلبات رحلات',
    createRideRequest: 'أنشئ طلباً عندما تحتاج إلى رحلة إلى حدث',
    edit: 'تعديل',
    editOffer: '✏️ تعديل عرض الرحلة',
    editRequest: '✏️ تعديل طلب الرحلة',
    updateSuccess: 'تم التحديث بنجاح!',
    updateFailed: 'فشل التحديث',
    eventNotFound: 'الحدث غير موجود',
    failedToCancelRideRequest: 'فشل إلغاء طلب الرحلة',
    myPosts: 'منشوراتي',
    noPosts: 'لا توجد منشورات بعد',
    createPost: 'انشر عرض رحلة أو طلب رحلة',
    myOffers: 'عروض الرحلات',
    rideOffer: 'عرض رحلة',
    rideRequest: 'طلب رحلة',
    matched: 'تم التوصيل'
  },

  // Create Event
  createEvent: {
    title: 'إنشاء حدث مشاركة',
    subtitle: 'قم بإعداد مشاركة لحدثك وشارك الرابط مع الحضور',
    creatingAs: 'إنشاء كـ',
    youWillBeAdmin: 'ستكون مدير هذا الحدث',
    eventDetails: 'تفاصيل الحدث',
    eventName: 'اسم الحدث',
    eventNamePlaceholder: 'مثال: حفلة عيد ميلاد سارة',
    date: 'التاريخ',
    time: 'الوقت',
    startTime: 'وقت البداية',
    endTime: 'وقت النهاية (اختياري)',
    location: 'الموقع',
    eventLocation: 'موقع الحدث',
    searchLocation: 'ابحث عن موقع الحدث...',
    privacy: 'الخصوصية',
    privateEvent: 'حدث خاص',
    publicEvent: 'حدث عام',
    privateDescription: 'فقط الأشخاص الذين لديهم رمز الوصول يمكنهم الانضمام',
    publicDescription: 'يمكن لأي شخص لديه الرابط الانضمام',
    accessCode: 'رمز الوصول',
    accessCodePlaceholder: 'مثال: PARTY2024',
    shareCodeHint: 'شارك هذا الرمز مع ضيوفك المدعوين',
    eventType: 'نوع الحدث',
    eventTypePlaceholder: 'اختر النوع',
    eventTypeConcert: '🎵 حفل / مهرجان',
    eventTypeDemonstration: '🪧 مظاهرة / احتجاج',
    eventTypeParty: '🎉 حفلة / عيد ميلاد',
    eventTypeConference: '🏫 مؤتمر / ورشة',
    eventTypeSports: '⚽ حدث رياضي',
    eventTypeWedding: '👰 زفاف',
    eventTypeOther: '📌 أخرى',
    eventVibe: 'أجواء الحدث',
    eventVibeFun: '🎉 مرح وتواصل',
    eventVibeChill: '😌 هادئ',
    eventVibeHighEnergy: '🔥 طاقة عالية',
    eventVibeCalm: '🧘 هدوء',
    eventVibePurpose: '✊ هادف',
    audienceSize: 'عدد الحضور المتوقع (تقريبي)',
    audienceSmall: '👥 صغير (أقل من ٢٠)',
    audienceMedium: '👥 متوسط (٢٠–١٠٠)',
    audienceLarge: '👥 كبير (١٠٠+)',
    aboutEvent: 'عن الحدث',
    eventShortDescription: 'وصف قصير (سطران)',
    eventShortDescriptionPlaceholder: 'مثال: لقاء اجتماعي مفتوح للجميع',
    eventNotes: 'ملاحظات مهمة (اختياري)',
    eventNotesPlaceholder: 'مثال: قد يكون هناك ازدحام مروري',
    isFeatured: 'هل هذا حدث مميز؟',
    isFeaturedHint: 'مثال: أول حدث، مجموعة جديدة، متكرر',
    eventImage: 'صورة الحدث',
    uploadImage: 'انقر لتحميل صورة',
    imageHint: 'حد أقصى 2 ميجابايت، JPG/PNG',
    imageTooLarge: 'حجم الصورة كبير جداً. الحد الأقصى 2 ميجابايت.',
    invalidImageType: 'يرجى اختيار ملف صورة صالح.',
    previewLabel: 'معاينة',
    previewPlaceholder: 'اسم حدثك',
    step1Title: 'ماذا ومتى',
    step2Title: 'أين',
    step3Title: 'من يمكنه الانضمام',
    createEventButton: 'إنشاء الحدث والحصول على الرابط',
    creating: 'جاري الإنشاء...',
    creatingEvent: 'جاري إنشاء حدثك...',
    backToHome: 'رجوع إلى الرئيسية',
    pleaseLogin: 'يرجى تسجيل الدخول لإنشاء حدث',
    fillAllFields: 'يرجى ملء جميع الحقول المطلوبة',
    setAccessCode: 'يرجى تعيين رمز وصول لحدثك الخاص',
    sessionExpired: 'انتهت الجلسة. يرجى تسجيل الدخول مرة أخرى.',
    failedToCreate: 'فشل إنشاء الحدث',
    tryAgain: 'فشل إنشاء الحدث. يرجى المحاولة مرة أخرى.',
    createdSuccessfully: 'تم إنشاء الحدث بنجاح!',
    eventCreated: 'تم إنشاء الحدث!',
    shareLink: 'شارك هذا الرابط مع الحضور',
    event: 'الحدث',
    when: 'متى',
    at: 'في',
    where: 'أين',
    shareThisLink: 'شارك هذا الرابط:',
    copy: 'نسخ',
    linkCopied: 'تم نسخ الرابط إلى الحافظة!',
    manageEvent: 'إدارة الحدث',
    goToEventPage: 'انتقل إلى صفحة الحدث',
    createAnother: 'إنشاء حدث آخر',
    redirectingToLogin: 'جاري إعادة التوجيه إلى تسجيل الدخول...'
  },

  // Admin
  admin: {
    login: 'تسجيل دخول المدير',
    dashboard: 'لوحة تحكم المدير',
    events: 'الأحداث',
    users: 'المستخدمون',
    statistics: 'الإحصائيات',
    settings: 'الإعدادات'
  },

  // Publish Ride
  publishRide: {
    offerRide: 'عرض تريمب',
    requestRide: 'بدور عتريمب',
    stepInfo: 'المعلومات',
    stepLocation: 'الموقع',
    stepDetails: 'التفاصيل',
    stepTiming: 'الوقت',
    loadingEvent: 'جاري تحميل الحدث...',
    publishingRide: 'جاري نشر رحلتك...',
    sendingRequest: 'جاري إرسال طلبك...',
    pleaseWait: 'يرجى الانتظار',
    yourInformation: 'معلوماتك',
    letOthersKnow: 'دع الآخرين يعرفون من أنت',
    name: 'الاسم',
    namePlaceholder: 'اسمك الكامل',
    phone: 'الهاتف',
    phonePlaceholder: '+972 50-123-4567',
    email: 'البريد الإلكتروني',
    emailPlaceholder: 'بريدك@الإلكتروني.com',
    gender: 'الجنس',
    male: 'ذكر',
    female: 'أنثى',
    yourLocation: 'موقعك',
    whereStartFrom: 'من أين ستبدأ؟',
    wherePickedUp: 'من أين سيتم استلامك؟',
    loadingMap: 'جاري تحميل الخريطة...',
    searchLocation: 'ابحث عن موقعك...',
    calculatingRoute: 'جاري حساب المسار...',
    tripDetails: 'تفاصيل الرحلة',
    configurePreferences: 'قم بتكوين تفضيلات رحلتك',
    tripDirection: 'اتجاه الرحلة',
    going: 'ذهاب',
    return: 'عودة',
    both: 'كلاهما',
    bothDifferent: 'كلاهما (مواقع مختلفة)',
    vehicleType: 'نوع المركبة',
    car: 'سيارة',
    publicVehicle: 'مواصلات عامة',
    goingLocation: 'موقع الذهاب (الإقلاع)',
    returnLocation: 'موقع العودة (النزول)',
    searchReturnLocation: 'ابحث عن موقع العودة...',
    returnTime: 'وقت العودة',
    flexible: 'مرن',
    dropOffDifferent: 'النزول في مكان مختلف',
    timeAndSeats: 'الوقت والمقاعد',
    pickupLocations: 'مواقع الإقلاع',
    dropoffLocations: 'مواقع النزول',
    pickupLocation: 'موقع الإقلاع',
    dropoffLocation: 'موقع النزول',
    addPickupLocation: 'إضافة موقع إقلاع',
    addDropoffLocation: 'إضافة موقع نزول',
    allowCustomPickup: 'السماح للركاب بطلب موقع إقلاع مخصص',
    arrivalTime: 'وقت الوصول المفضل',
    eventTime: 'الحدث',
    availableSeats: 'المقاعد المتاحة',
    passengers: 'الركاب',
    passengerPreference: 'تفضيل الراكب',
    anyone: 'أي شخص',
    men: 'رجال',
    women: 'نساء',
    payment: 'الدفع',
    setPaymentPreferences: 'قم بتعيين تفضيلات الدفع الخاصة بك',
    freeRide: 'رحلة مجانية',
    tipWelcome: 'البقشيش مرحب به',
    required: 'مطلوب',
    amount: 'المبلغ',
    suggestedMax: 'الحد الأقصى المقترح',
    paymentMethod: 'طريقة الدفع',
    cash: 'نقد',
    bit: 'Bit',
    paybox: 'PayBox',
    additionalNotes: 'ملاحظات إضافية',
    anythingElse: 'أي شيء آخر للمشاركة؟',
    notesPlaceholderOffer: 'طراز السيارة، تفضيلات الموسيقى، نقطة اللقاء...',
    notesPlaceholderRequest: 'طلبات خاصة، مرونة في التوقيت...',
    publishRide: 'نشر الرحلة',
    sendRequest: 'إرسال الطلب',
    welcomeBack: 'مرحباً بعودتك! تم إرسال رمز تسجيل الدخول.',
    codeSent: 'تم إرسال رمز التحقق!',
    failedToSendOTP: 'فشل إرسال رمز التحقق',
    enter6DigitOTP: 'يرجى إدخال رمز التحقق المكون من 6 أرقام',
    verifiedSuccess: 'تم التحقق بنجاح!',
    invalidOTP: 'رمز التحقق غير صحيح',
    ridePublished: '🎉 تم نشر الرحلة!',
    requestSent: '🎉 تم إرسال الطلب!',
    failedToPublish: 'فشل النشر',
    fillRequiredFields: 'يرجى ملء جميع الحقول المطلوبة',
    selectPickupLocation: 'يرجى تحديد موقع الاستلام',
    enterEmail: 'يرجى إدخال بريدك الإلكتروني',
    sendingCode: 'إرسال رمز التحقق',
    sendingCodeTo: 'نحن نرسل رمزاً إلى',
    createAccount: 'إنشاء حساب',
    welcomeBackTitle: 'مرحباً بعودتك!',
    enterCodeToCreate: 'أدخل الرمز لإنشاء حسابك',
    enterCodeToLogin: 'لديك حساب بالفعل. أدخل الرمز لتسجيل الدخول.',
    sending: 'جاري الإرسال...',
    resendCode: 'إعادة إرسال الرمز',
    verifying: 'جاري التحقق...',
    verifyAndPublish: 'التحقق والنشر',
    // Bus route stops
    pickupStops: 'مواقع الاستلام',
    pickupStopsDesc: 'أضف المواقع التي ستستلم منها الركاب',
    dropoffStops: 'مواقع النزول',
    dropoffStopsDesc: 'أضف المواقع التي ستنزل فيها الركاب بعد الحدث',
    searchStopLocation: 'ابحث عن موقع...',
    stopNickname: 'اسم الموقع',
    stopNicknamePlaceholder: 'مثال: المحطة المركزية، الساحة الرئيسية',
    stopTime: 'وقت الاستلام',
    addPickupStop: 'إضافة موقع استلام آخر',
    addDropoffStop: 'إضافة موقع نزول آخر',
    removeStop: 'إزالة هذا الموقع',
    autoGeneratedReturn: 'تم إنشاء مواقع النزول تلقائياً من مسار الاستلام. يمكنك تعديلها أدناه.',
    // Nearby offers
    nearbyOffersFound: 'تم العثور على رحلات قريبة!',
    nearbyOffersDesc: 'وجدنا بعض الرحلات بالقرب من موقعك. يمكنك الانضمام إلى إحداها بدلاً من إنشاء طلب جديد:',
    seatsAvailable: 'مقاعد',
    viewOffer: 'عرض العرض',
    createRequestAnyway: 'إنشاء الطلب على أي حال',
    // Vehicle type and organizers
    selectVehicleType: 'اختر نوع المركبة',
    additionalOrganizers: 'منظمون إضافيون',
    addOrganizersHint: 'اضغط على + لإضافة منظمين إضافيين يمكن التواصل معهم',
    organizerName: 'اسم المنظم',
    organizerPhone: 'رقم الهاتف',
    hidePhone: 'إخفاء رقم هاتفي حتى القبول',
    disableJoinRequest: 'تواصل عبر واتساب فقط',
    disableJoinRequestHint: 'إلغاء زر "طلب الإنضمام" - يمكن للركاب التواصل معك عبر واتساب فقط',
    editOffer: 'تعديل عرض الرحلة',
    editRequest: 'تعديل طلب الرحلة',
    updateRide: 'تحديث',
    updateSuccess: 'تم التحديث بنجاح!',
    updateFailed: 'فشل التحديث'
  },

  // Demonstrations
  demonstrations: {
    heroTitle: 'منوصل سوا. <br> ومنوقف سوا.',
    heroSubtitle: 'تنسيق آمن وأسهل للمظاهرات — شارك/ي بسيارة مع ناس بتوثق/ي فيهم، وفّري مصروف، ووصل/ي بوقت.',
    note: 'Trempi هدفه يساعد بالتنسيق الآمن والمسؤول. اتبع/ي القوانين وخلي/ي الخصوصية أولوية.',
    chipSafety: 'تنسيق بأولوية الأمان',
    chipCost: 'توفير بالمصاريف',
    chipCommunity: 'نطلع كمجتمع',
    joinTitle: 'انضم/ي لمظاهرة',
    codePlaceholder: 'أدخل/ي كود المظاهرة',
    joinButton: 'انضم/ي',
    helperText: 'معك كود من المنظّم؟ انضم/ي لمسار المشاركة والسيارات.',
    pleaseEnterCode: 'يرجى إدخال كود المظاهرة',
    invalidCode: 'كود المظاهرة غير صحيح. يرجى المحاولة مرة أخرى.',
    eventFound: 'تم العثور على المظاهرة!',
    cardOrganizeTitle: 'نظّم/ي مظاهرة',
    cardOrganizeSubtitle: 'أنشئ/ي مساحة تنسيق وشارك/ي الكود مع مجموعتك.',
    cardOfferTitle: 'اعرض/ي توصيلة',
    cardOfferSubtitle: 'شارك/ي مقاعد فاضية مع ناس رايحين على نفس المكان.',
    cardRequestTitle: 'اطلب/ي توصيلة',
    cardRequestSubtitle: 'اطلب/ي مقعد وبتوصلك اقتراحات للي بنفس الاتجاه.',
    safetyHeading: 'قبل ما تطلع/ي',
    safetyItem1: 'شارك/ي نقاط الالتقاء بس مع ناس موثوقين',
    safetyItem2: 'قلّل/ي معلوماتك الشخصية',
    safetyItem3: 'اتفق/ي على نقطة بديلة وخطة احتياط',
    safetyItem4: 'إذا حسّيت/ي بعدم أمان، انسحب/ي وارجع/ي تواصل/ي مع المجموعة',
    footerText: 'لديك حساب بالفعل؟',
    footerButton: 'تسجيل الدخول / إنشاء حساب',
    // Create Demonstration
    createTitle: 'إنشاء مظاهرة',
    createSubtitle: 'أنشئ/ي مساحة تنسيق لمظاهرتك وشارك/ي الكود مع المشاركين',
    detailsTitle: 'تفاصيل المظاهرة',
    nameLabel: 'اسم المظاهرة',
    namePlaceholder: 'مثال: مسيرة السلام - تل أبيب',
    locationTitle: 'الموقع',
    locationLabel: 'موقع المظاهرة',
    searchLocation: 'ابحث عن موقع المظاهرة...',
    privacyTitle: 'الخصوصية',
    creating: 'جاري الإنشاء...',
    createButton: 'إنشاء المظاهرة والحصول على الكود',
    created: 'تم إنشاء المظاهرة!',
    shareLink: 'شارك/ي هذا الكود مع المشاركين لتنسيق المشاركة',
    demonstration: 'المظاهرة',
    manage: 'إدارة المظاهرة',
    goToPage: 'الذهاب لصفحة المظاهرة',
    createAnother: 'إنشاء مظاهرة أخرى',
    backToHome: 'العودة للمظاهرات',
    alwaysPublic: 'المظاهرات دائماً عامة',
    publicNote: 'جميع المظاهرات مرئية للجميع على المنصة.'
  }
};
